import { normalize } from 'normalizr'
import fetch from './fetch'

export function fetchSchema(endpoint, schema, optionOverrides) {
  const options = {
    method: 'get',
    data: undefined,
    responseModifier: resp => resp,
    ...optionOverrides,
  }

  return fetch(endpoint, options.method, options.data).then(
    ({ response }) => ({ response: normalize(options.responseModifier(response), schema) }),
    error => error
  )
}

export function deleteSchema(endpoint, schema, id) {
  return fetch(endpoint, 'delete').then(
    () => ({ response: { deleteEntity: `${schema.getKey()}.${id}` } }),
    error => error
  )
}



/** WEBPACK FOOTER **
 ** ./src/services/api/fetch-schema.js
 **/